'use client';

import { BiomeCombinedProviders } from '@biom3/react';
import { getTheme } from '../theme';
import { storefrontType } from '../utils/env';

export function ThemeProvider({ children }: { children: React.ReactNode }) {
  const storefrontTheme = getTheme(storefrontType);

  // Could not get internal input theme definition, but we replicated it
  return <BiomeCombinedProviders theme={storefrontTheme as any}>{children}</BiomeCombinedProviders>;
}
